import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import JunoButton from '../../../../../new-ui/components/common/JunoButton';

const PaymentProcessing = ({ imageBaseUrl, handleNavigate }) => {
    useEffect(() => {
        const timeId = window.setTimeout(() => {
            handleNavigate();
        }, 5000);

        return () => {
            window.clearTimeout(timeId);
        };
    }, []);

    return (
        <div className="flex justify-center items-center md:!mt-5">
            <div
                className="flex flex-col gap-6 md:w-[440px] mt-0 md:mt-[60px]
          p-[32px_16px] lg:p-[32px] 
          rounded-[12px] outline outline-1 outline-offset-[-1px] bg-bulkpay-card-bg outline-bulkpay-card-outline">
                <p className="text-text text-lg font-semibold leading-7 uppercase text-center">
                    Your bulk payment is now processing
                </p>

                <p className="text-balanceCard-manage uppercase text-sm font-medium leading-tight text-center">
                    Your payment file has been uploaded successfully and is now being processed.
                </p>

                <JunoButton type={"secondary"} onClick={() => handleNavigate()}>Close</JunoButton>
            </div>
        </div>
    );
};

PaymentProcessing.propTypes = {
    imageBaseUrl: PropTypes.string.isRequired,
    handleNavigate: PropTypes.func.isRequired,
};

export default PaymentProcessing;
